import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

type Props = {
  messages: T2PayHomeMessages;
  handleOpen: (selected?: unknown) => void;
};

const NoBankAccountMessage = ({ messages, handleOpen }: Props) => {
  return (
    <MDBox width="82%" textAlign="center" mx="auto" my={4}>
      <MDBox mb={1}>
        <MDTypography variant="h5" color="dark" fontWeight="bold">
          {messages.noBankAccountMessage}
        </MDTypography>
      </MDBox>
      <MDBox mb={2}>
        <MDTypography variant="body2" color="text">
          {messages.noBankAccountDescription}
        </MDTypography>
      </MDBox>
      <MDButton
        onClick={() => handleOpen()}
        variant="gradient"
        color="dark"
        endIcon={<AddCircleOutlineIcon />}
      >
        {messages.addBankAccountButtonLabel}
      </MDButton>
    </MDBox>
  );
};

export default NoBankAccountMessage;
